import { Component, ErrorInfo, ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { t } from '../i18n';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Portal error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ textAlign: 'center', py: 12 }}>
          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            {t('errorBoundary.title')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
            {t('errorBoundary.body')}
          </Typography>
          <Button
            variant="outlined"
            onClick={() => {
              this.setState({ hasError: false });
              window.location.reload();
            }}
          >
            {t('errorBoundary.reloadButton')}
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}
